export const CART_STATUS = 'cart_status'
export const CART_EMAIL = 'cart_email'
export const CART_LOAD_PROD = 'cart_load_prod'
export const GIFT_PARAM = 'gift'
